var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',[_c('header',[_c('h2',[_vm._v(_vm._s(_vm.$dt(_vm.title)))])]),_c('main',[_c('simple-page',{attrs:{"sections":_vm.sections}}),_c('hr',{staticStyle:{"margin":"3em 0"}}),_c('signup-form',{attrs:{"formInfo":_vm.formInfo,"formKey":_vm.formKey}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }